<template>
    <card class="card-plain card-news" v-loading="statusItem === 'fetching'">
        <div class="card-title text-left">
            <div class="row">
                <div class="col-1 mt-2 no-div-break">
                  <i :class="newsIcons[item.type]"/>
                </div>
                <div class="col-11 no-div-break">
                    <h4 class="mb-0 mt-0">{{ item.title }}</h4>
                    <div class="text mb-3">
                        <small class="text-muted" v-if="item.createdBy">
                            {{ $t('by {author}', { author: item.createdBy ? item.createdBy.username : ''}) }}
                        </small>
                        <br />
                        <small class="text-muted" v-if="getNewsTitle(item)">
                            {{ $t('for {teams}', { teams: getNewsTitle(item)}) }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-image">
            <img v-if="item.image" :src="`/api/image/${item.image}`" onerror="this.src = '/static/img/placeholder.png'" alt="news image">
            <img v-else src="/static/img/placeholder.png">
        </div>
        <div class="card-news-date">{{ item.createdAt | formatDateTime }}</div>
        <div class="card-content text">
            <small v-html="item.content"/>
        </div>
    </card>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import NewsBox from 'src/components/Dashboard/Components/NewsBox'
  import PButton from '../../UIComponents/Button'
  import { newsIcons } from '../../../util/icons'

  export default {
    name: 'NewsDetails',
    components: {
      PButton,
      NewsBox
    },
    data () {
      return {
        newsIcons
      }
    },
    mounted () {
      this.init()
    },
    computed: {
      ...mapState('news', {
        item: state => state.item,
        statusItem: state => state.statusItem
      })
    },
    methods: {
      ...mapActions('news', [
          'getNewsDetails'
        ]
      ),

      getNewsTitle (item) {
        if (item.teams) {
          return item.teams.map(x => x.title).join(', ')
        }

        return ''
      },

      init () {
        this.getNewsDetails({ id: this.$route.params.id })
      }
    },
    watch: {
      statusItem (val) {
        if (val === 'failure') {
          this.$notify({ type: 'danger', message: this.$t('Error') })
        }
      }
    }
  }
</script>
<style scoped lang="scss">
    .card-news {
        max-width: 800px !important;
        margin: auto;
        padding-bottom: 2em;

        .text {
            font-weight: 400;
            font-size: 1.5em;
            line-height: initial;
            small {
                font-size: 0.75em;
                font-weight: 300;
            }
        }

        .card-content {
            padding-top: 1em;
            text-align: justify;
        }

        &-date {
            text-align: right;
            padding-top: 7px;
        }
        .card-image img {
            max-height: 200px;
            width: 100%;
            object-fit: cover;
            border-radius: 12px 12px 0 0;
        }
        .no-div-break {
          display: inline;
          float: left;
        }
    }
</style>
